// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Benefits_wrap__vYyB5","item":"Benefits_item__kX86w"};